import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  useTheme,
  Text,
  Flex,
  Box,
} from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { ReactComponent as StarFilledSVG } from '../../../logos/starFilled.svg';
import { toTitleCase } from '../../../utils';

const SeeWhyModal = ({ isOpen, onClose, searchParameters, provider }) => {
  const theme = useTheme();
  const attributes = [];
  let attribute = '';
  const getDoctorAttributes = () => {
    if (searchParameters?.EPISODES) {
      attribute = `This Doctor treated ${provider.EPISODE_VOLUME} patients with ${provider.EPISODE_NM}.`;
      attributes.push(attribute);
    }
    if (searchParameters?.DIAGNOSIS || searchParameters?.PROCEDURES) {
      attribute = `This Doctor Treated ${provider.PATIENT_CNT}`;
      attributes.push(attribute);
    }
    if (searchParameters?.SPECIALTY) {
      //EPISODES is higher than SPECIALTY, so we show specialty if we don't have episodes
      if (!searchParameters.EPISODES) {
        if (provider.PPI_SCORE >= 4) {
          attribute = `This doctor performs better than ${
            provider.PPI_SCORE === 4 ? '60%' : '80%'
          } of their peers aggregated across all episodes they treat.`;
          attributes.push(attribute);
        }
      }
    }
  };

  const getGeoLocationAttribute = () => {
    const providerLocatedIn = [];
    if (searchParameters?.ADDRESS_ZIP_CODE) {
      providerLocatedIn.push(provider.POSTAL_CD);
    }
    if (searchParameters?.ADDRESS_CITY) {
      providerLocatedIn.push(toTitleCase(provider.CITY_NM));
    }
    if (searchParameters?.ADDRESS_COUNTY) {
      providerLocatedIn.push(toTitleCase(provider.COUNTY_NM));
    }
    if (searchParameters?.ADDRESS_STATE) {
      providerLocatedIn.push(provider.STATE_CD);
    }
    if (providerLocatedIn.length > 0) {
      attributes.push(
        `This Doctor is located in ${providerLocatedIn.join(', ')}`,
      );
    }
  };

  getDoctorAttributes();
  getGeoLocationAttribute();
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent paddingBottom='25px'>
        <ModalHeader color={theme.colors?.darkGrey2} fontWeight={600}>
          <Flex alignItems='center'>
            <StarFilledSVG width='25px' height='25px' />
            <Text marginLeft='10px'>Why We Recommend This Doctor</Text>
          </Flex>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody marginTop='15px'>
          {attributes.map((attribute, index) => (
            <Flex key={index} marginBottom='20px' justifyContent='flex-start'>
              <FontAwesomeIcon
                icon={faCheck}
                color={theme.colors?.green}
                style={{ width: '20px', height: '20px', marginTop: '5px' }}
              />
              <Text marginLeft='15px'>{attribute}</Text>
            </Flex>
          ))}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default SeeWhyModal;
